/** localStorage draft for Set A profile page — saved locally until final survey submit (ploomsurvey pattern). */
export const SET_A_PROFILE_STORAGE_KEY = 'ldsurvey:setAProfile';

export type SetAProfileAnswers = {
  name: string;
  email: string;
  race: string;
  state: string;
  area: string;
};

export const SET_A_RACES = ['Malay', 'Chinese', 'Indian', 'Other'] as const;

export const SET_A_STATES = [
  'Johor',
  'Kedah',
  'Kelantan',
  'Kuala Lumpur',
  'Melaka',
  'Negeri Sembilan',
  'Pahang',
  'Perak',
  'Perlis',
  'Pulau Pinang',
  'Sabah',
  'Sarawak',
  'Selangor',
  'Terengganu',
] as const;

export const SET_A_AREA_MAX_LENGTH = 160;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  return EMAIL_PATTERN.test(trimmed);
}

export function readSetAProfileAnswers(): Partial<SetAProfileAnswers> | null {
  try {
    const raw = localStorage.getItem(SET_A_PROFILE_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const p = o as Record<string, unknown>;
    return {
      name: typeof p.name === 'string' ? p.name : '',
      email: typeof p.email === 'string' ? p.email : '',
      race: typeof p.race === 'string' ? p.race : '',
      state: typeof p.state === 'string' ? p.state : '',
      area: typeof p.area === 'string' ? p.area : '',
    };
  } catch {
    return null;
  }
}

export function writeSetAProfileAnswers(data: SetAProfileAnswers): void {
  try {
    localStorage.setItem(SET_A_PROFILE_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export function clearSetAProfileAnswers(): void {
  try {
    localStorage.removeItem(SET_A_PROFILE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSetAProfileComplete(): boolean {
  const s = readSetAProfileAnswers();
  if (!s) return false;
  const name = s.name?.trim() ?? '';
  const email = s.email?.trim() ?? '';
  const race = s.race?.trim() ?? '';
  const state = s.state?.trim() ?? '';
  const area = s.area?.trim() ?? '';
  return (
    name.length > 0 &&
    isValidEmail(email) &&
    race.length > 0 &&
    state.length > 0 &&
    area.length > 0 &&
    area.length <= SET_A_AREA_MAX_LENGTH
  );
}
